import {Routes} from '@angular/router';
import {DocumentsPageComponent} from './documents-page.component';

/**
 * Created by Arturo Campos on 20/09/18.
 */
const routes: Routes = [{
    path: 'documents',
    component: DocumentsPageComponent,
    data: {impersonationAllowed: true}
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/documents/documents-pages.routing.ts